<template>
  <div class="dashboard">
    <!-- 头部 -->
    <div class="header">
      <div class="user-info">
        <span class="username">👤 {{ username }}</span>
        <RoleSelector @role-changed="handleRoleChanged" />
        <button class="btn-logout" @click="logout">退出登录</button>
      </div>
      <h1>智能社媒口碑聆听</h1>
      <p>口碑全景观察空间</p>
      <!-- 顶部工具栏：快速筛选与操作聚合 -->
      <div class="top-toolbar">
        <div class="toolbar-left">
          <div class="quick-filters">
            <div class="quick-filter-item">
              <label>情感</label>
              <div class="searchable-select">
                <input 
                  type="text" 
                  v-model="searchQueries.sentiment" 
                  @focus="showDropdown.sentiment = true"
                  @input="filterOptions('sentiment')"
                  @blur="hideDropdown('sentiment')"
                  :placeholder="filters.sentiment === 'all' ? '全部' : filters.sentiment"
                  class="search-input"
                />
                <ul v-show="showDropdown.sentiment && filteredOptions.sentiment.length > 0" class="dropdown-list">
                  <li @click="selectOption('sentiment', 'all')" class="dropdown-item">
                    全部
                  </li>
                  <li 
                    v-for="opt in filteredOptions.sentiment" 
                    :key="opt.value" 
                    @click="selectOption('sentiment', opt.value)"
                    class="dropdown-item"
                  >
                    {{ opt.value }} ({{ opt.count }})
                  </li>
                </ul>
              </div>
            </div>
            <div class="quick-filter-item">
              <label>车系</label>
              <div class="searchable-select">
                <input 
                  type="text" 
                  v-model="searchQueries.seriesName" 
                  @focus="showDropdown.seriesName = true"
                  @input="filterOptions('seriesName')"
                  @blur="hideDropdown('seriesName')"
                  :placeholder="filters.seriesName === 'all' ? '全部' : filters.seriesName"
                  class="search-input"
                />
                <ul v-show="showDropdown.seriesName && filteredOptions.seriesName.length > 0" class="dropdown-list">
                  <li @click="selectOption('seriesName', 'all')" class="dropdown-item">
                    全部
                  </li>
                  <li 
                    v-for="opt in filteredOptions.seriesName" 
                    :key="opt.value" 
                    @click="selectOption('seriesName', opt.value)"
                    class="dropdown-item"
                  >
                    {{ opt.value }} ({{ opt.count }})
                  </li>
                </ul>
              </div>
            </div>
            <div class="quick-filter-item">
              <label>车型</label>
              <div class="searchable-select">
                <input 
                  type="text" 
                  v-model="searchQueries.carName" 
                  @focus="showDropdown.carName = true"
                  @input="filterOptions('carName')"
                  @blur="hideDropdown('carName')"
                  :placeholder="filters.carName === 'all' ? '全部' : filters.carName"
                  class="search-input"
                />
                <ul v-show="showDropdown.carName && filteredOptions.carName.length > 0" class="dropdown-list">
                  <li @click="selectOption('carName', 'all')" class="dropdown-item">
                    全部
                  </li>
                  <li 
                    v-for="opt in filteredOptions.carName" 
                    :key="opt.value" 
                    @click="selectOption('carName', opt.value)"
                    class="dropdown-item"
                  >
                    {{ opt.value }} ({{ opt.count }})
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="active-filter-tags" v-if="activeFiltersList.length">
            <span class="filter-tag" v-for="f in activeFiltersList" :key="f.key+f.value">
              {{ getFilterLabel(f.key) }}: {{ f.value }}
            </span>
          </div>
        </div>
        <div class="toolbar-right">
          <button class="btn-compare" @click="goToComparison">🆚 对比</button>
          <button class="btn-toggle-filters" @click="showFilters = !showFilters">{{ showFilters ? '收起筛选' : '更多筛选' }}</button>
          <button class="btn-reset" @click="resetFilters">重置</button>
          <button class="btn-apply" @click="applyFilters">应用</button>
          <button class="btn-optimize" @click="openOptimizationWizard">🧠 优化</button>
        </div>
      </div>
    </div>

    <!-- 筛选区域（折叠） -->
    <div class="filter-section" v-show="showFilters">
      <h2>数据筛选</h2>
      <div class="filter-grid">
        <div class="filter-item">
          <label>情感倾向</label>
          <div class="searchable-select">
            <input 
              type="text" 
              v-model="searchQueries.sentiment" 
              @focus="showDropdown.sentiment = true"
              @input="filterOptions('sentiment')"
              @blur="hideDropdown('sentiment')"
              placeholder="搜索情感倾向..."
              class="search-input"
            />
            <ul v-show="showDropdown.sentiment && filteredOptions.sentiment.length > 0" class="dropdown-list">
              <li @click="selectOption('sentiment', 'all')" class="dropdown-item">
                全部
              </li>
              <li 
                v-for="opt in filteredOptions.sentiment" 
                :key="opt.value" 
                @click="selectOption('sentiment', opt.value)"
                class="dropdown-item"
              >
                {{ opt.value }} ({{ opt.count }})
              </li>
            </ul>
          </div>
        </div>

        <div class="filter-item">
          <label>车系</label>
          <div class="searchable-select">
            <input 
              type="text" 
              v-model="searchQueries.seriesName" 
              @focus="showDropdown.seriesName = true"
              @input="filterOptions('seriesName')"
              @blur="hideDropdown('seriesName')"
              placeholder="搜索车系..."
              class="search-input"
            />
            <ul v-show="showDropdown.seriesName && filteredOptions.seriesName.length > 0" class="dropdown-list">
                  <li @click="selectOption('seriesName', 'all')" class="dropdown-item">
                    全部
                  </li>
                  <li 
                    v-for="opt in filteredOptions.seriesName" 
                    :key="opt.value" 
                    @click="selectOption('seriesName', opt.value)"
                    class="dropdown-item"
                  >
                    {{ opt.value }} ({{ opt.count }})
                  </li>
                </ul>
          </div>
        </div>

        <div class="filter-item">
          <label>车型</label>
          <div class="searchable-select">
            <input 
              type="text" 
              v-model="searchQueries.carName" 
              @focus="showDropdown.carName = true"
              @input="filterOptions('carName')"
              @blur="hideDropdown('carName')"
              placeholder="搜索车型..."
              class="search-input"
            />
            <ul v-show="showDropdown.carName && filteredOptions.carName.length > 0" class="dropdown-list">
                  <li @click="selectOption('carName', 'all')" class="dropdown-item">
                    全部
                  </li>
                  <li 
                    v-for="opt in filteredOptions.carName" 
                    :key="opt.value" 
                    @click="selectOption('carName', opt.value)"
                    class="dropdown-item"
                  >
                    {{ opt.value }} ({{ opt.count }})
                  </li>
                </ul>
          </div>
        </div>

        <div class="filter-item">
          <label>年份</label>
          <div class="searchable-select">
            <input 
              type="text" 
              v-model="searchDropdowns.year.search" 
              @focus="searchDropdowns.year.open = true"
              @input="searchDropdowns.year.search = $event.target.value"
              @blur="setTimeout(() => searchDropdowns.year.open = false, 200)"
              placeholder="搜索年份..."
              class="search-input"
            />
            <ul v-show="searchDropdowns.year.open && filteredOptions.year.length > 0" class="dropdown-list">
              <li @click="selectSearchOption('year', 'all')" class="dropdown-item">
                全部
              </li>
              <li 
                v-for="opt in filteredOptions.year" 
                :key="opt.value" 
                @click="selectSearchOption('year', opt.value)"
                class="dropdown-item"
              >
                {{ opt.value }} ({{ opt.count }})
              </li>
            </ul>
          </div>
        </div>

        <div class="filter-item">
          <label>燃料类型</label>
          <div class="searchable-select">
            <input 
              type="text" 
              v-model="searchDropdowns.fuelForm.search" 
              @focus="searchDropdowns.fuelForm.open = true"
              @input="searchDropdowns.fuelForm.search = $event.target.value"
              @blur="setTimeout(() => searchDropdowns.fuelForm.open = false, 200)"
              placeholder="搜索燃料类型..."
              class="search-input"
            />
            <ul v-show="searchDropdowns.fuelForm.open && filteredOptions.fuelForm.length > 0" class="dropdown-list">
              <li @click="selectSearchOption('fuelForm', 'all')" class="dropdown-item">
                全部
              </li>
              <li 
                v-for="opt in filteredOptions.fuelForm" 
                :key="opt.value" 
                @click="selectSearchOption('fuelForm', opt.value)"
                class="dropdown-item"
              >
                {{ opt.value }} ({{ opt.count }})
              </li>
            </ul>
          </div>
        </div>

        <div class="filter-item">
          <label>评论类型</label>
          <div class="searchable-select">
            <input 
              type="text" 
              v-model="searchDropdowns.carReviewType.search" 
              @focus="searchDropdowns.carReviewType.open = true"
              @input="searchDropdowns.carReviewType.search = $event.target.value"
              @blur="setTimeout(() => searchDropdowns.carReviewType.open = false, 200)"
              placeholder="搜索评论类型..."
              class="search-input"
            />
            <ul v-show="searchDropdowns.carReviewType.open && filteredOptions.carReviewType.length > 0" class="dropdown-list">
              <li @click="selectSearchOption('carReviewType', 'all')" class="dropdown-item">
                全部
              </li>
              <li 
                v-for="opt in filteredOptions.carReviewType" 
                :key="opt.value" 
                @click="selectSearchOption('carReviewType', opt.value)"
                class="dropdown-item"
              >
                {{ opt.value }} ({{ opt.count }})
              </li>
            </ul>
          </div>
        </div>

        <div class="filter-item">
          <label>文本类型</label>
          <div class="searchable-select">
            <input 
              type="text" 
              v-model="searchDropdowns.textType.search" 
              @focus="searchDropdowns.textType.open = true"
              @input="searchDropdowns.textType.search = $event.target.value"
              @blur="setTimeout(() => searchDropdowns.textType.open = false, 200)"
              placeholder="搜索文本类型..."
              class="search-input"
            />
            <ul v-show="searchDropdowns.textType.open && filteredOptions.textType.length > 0" class="dropdown-list">
              <li @click="selectSearchOption('textType', 'all')" class="dropdown-item">
                全部
              </li>
              <li 
                v-for="opt in filteredOptions.textType" 
                :key="opt.value" 
                @click="selectSearchOption('textType', opt.value)"
                class="dropdown-item"
              >
                {{ opt.value }} ({{ opt.count }})
              </li>
            </ul>
          </div>
        </div>

        <div class="filter-item">
          <label>复杂度</label>
          <div class="searchable-select">
            <input 
              type="text" 
              v-model="searchDropdowns.complexity.search" 
              @focus="searchDropdowns.complexity.open = true"
              @input="searchDropdowns.complexity.search = $event.target.value"
              @blur="setTimeout(() => searchDropdowns.complexity.open = false, 200)"
              placeholder="搜索复杂度..."
              class="search-input"
            />
            <ul v-show="searchDropdowns.complexity.open && filteredOptions.complexity.length > 0" class="dropdown-list">
              <li @click="selectSearchOption('complexity', 'all')" class="dropdown-item">
                全部
              </li>
              <li 
                v-for="opt in filteredOptions.complexity" 
                :key="opt.value" 
                @click="selectSearchOption('complexity', opt.value)"
                class="dropdown-item"
              >
                {{ opt.value }} ({{ opt.count }})
              </li>
            </ul>
          </div>
        </div>

        <div class="filter-item">
          <label>开始日期</label>
          <input type="date" v-model="filters.startDate" @change="applyFilters">
        </div>

        <div class="filter-item">
          <label>结束日期</label>
          <input type="date" v-model="filters.endDate" @change="applyFilters">
        </div>
      </div>
    </div>

    <!-- 核心指标 -->
    <div class="metrics-grid">
      <div class="metric-card clickable" @click="openDetailModal('全部评论数据详情')" aria-label="查看全部评论详情">
        <div class="metric-icon">📊</div>
        <div class="metric-content">
          <div class="metric-value">{{ stats.total_count || 0 }}</div>
          <div class="metric-label">总评论数</div>
        </div>
      </div>
      <div class="metric-card positive clickable" @click="openDetailModal('正面情感数据详情', { sentiment: 'positive' })" aria-label="查看正面评论详情">
        <div class="metric-icon">😊</div>
        <div class="metric-content">
          <div class="metric-value">{{ stats.positive_count || 0 }}</div>
          <div class="metric-label">正面评论</div>
        </div>
      </div>
      <div class="metric-card negative clickable" @click="openDetailModal('负面情感数据详情', { sentiment: 'negative' })" aria-label="查看负面评论详情">
        <div class="metric-icon">😔</div>
        <div class="metric-content">
          <div class="metric-value">{{ stats.negative_count || 0 }}</div>
          <div class="metric-label">负面评论</div>
        </div>
      </div>
      <div class="metric-card neutral clickable" @click="openDetailModal('中性情感数据详情', { sentiment: 'neutral' })" aria-label="查看中性评论详情">
        <div class="metric-icon">😐</div>
        <div class="metric-content">
          <div class="metric-value">{{ stats.neutral_count || 0 }}</div>
          <div class="metric-label">中性评论</div>
        </div>
      </div>
      <div class="metric-card score">
        <div class="metric-icon">⭐</div>
        <div class="metric-content">
          <div class="metric-value">{{ avgScore }}</div>
          <div class="metric-label">平均情感分</div>
        </div>
      </div>
    </div>

    <!-- 图表区域 -->
    <div class="charts-row">
      <div class="chart-card half">
        <h3>正负面占比</h3>
        <div ref="sentimentPie" class="chart"></div>
      </div>
      <div class="chart-card half">
        <h3>媒体第一印象</h3>
        <div ref="wordCloud" class="chart"></div>
      </div>
    </div>

    <div class="chart-card">
      <h3>话题情绪分布</h3>
      <div ref="topicSentiment" class="chart"></div>
    </div>

    <!-- 详情弹窗 -->
    <transition name="modal">
      <div v-if="showDetailModal" class="detail-modal" @click.self="closeDetailModal">
        <div class="detail-modal-content">
          <div class="detail-modal-header">
            <div class="detail-modal-title">
              <span>📊</span>
              <span>{{ detailTitle }}</span>
            </div>
            <button class="detail-modal-close" @click="closeDetailModal">×</button>
          </div>
          
          <div class="detail-modal-filters">
            <div v-for="(value, key) in detailFilters" :key="key" class="detail-filter-tag">
              <span>{{ getFilterLabel(key) }}: {{ value }}</span>
              <button class="remove-filter" @click="removeDetailFilter(key)">×</button>
            </div>
            <button class="add-filter-btn" @click="showFilterDialog = true">+ 添加筛选</button>
          </div>

          <div class="detail-modal-body">
            <div class="detail-stats">
              <div class="stat-item">
                <span class="stat-label">总数</span>
                <span class="stat-value">{{ detailStats.total_count || 0 }}</span>
              </div>
              <div class="stat-item positive">
                <span class="stat-label">正面</span>
                <span class="stat-value">{{ detailStats.positive_count || 0 }}</span>
              </div>
              <div class="stat-item negative">
                <span class="stat-label">负面</span>
                <span class="stat-value">{{ detailStats.negative_count || 0 }}</span>
              </div>
              <div class="stat-item neutral">
                <span class="stat-label">中性</span>
                <span class="stat-value">{{ detailStats.neutral_count || 0 }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">平均分</span>
                <span class="stat-value">{{ detailAvgScore }}</span>
              </div>
            </div>

            <div class="detail-data-list">
              <div v-for="(item, idx) in detailDataList" :key="idx" class="detail-data-item">
                <div class="detail-item-header">
                  <div class="detail-item-meta">
                    <span class="detail-meta-tag">🚗 {{ item.car_name || '未知车型' }}</span>
                    <span class="detail-meta-tag">📅 {{ item.series_name || '未知车系' }}</span>
                    <span class="detail-meta-tag">🕒 {{ item.create_time || '未知时间' }}</span>
                  </div>
                  <span :class="['detail-sentiment-badge', getSentimentClass(item.sentiment)]">
                    {{ getSentimentLabel(item.sentiment) }}
                  </span>
                </div>
                <div class="detail-item-content">{{ item.original_sentence || '暂无内容' }}</div>
                <div v-if="getAspects(item.opinion_analysis).length" class="detail-item-tags">
                  <span v-for="(aspect, i) in getAspects(item.opinion_analysis)" :key="i" class="detail-tag">
                    {{ aspect }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 筛选对话框 -->
    <transition name="modal">
      <div v-if="showFilterDialog" class="filter-dialog" @click.self="showFilterDialog = false">
        <div class="filter-dialog-content">
          <div class="filter-dialog-header">
            <h3>添加筛选条件</h3>
            <button class="filter-dialog-close" @click="showFilterDialog = false">×</button>
          </div>
          <div class="filter-dialog-body">
            <div class="filter-select-group">
              <label>选择筛选维度：</label>
              <select v-model="newFilterDimension" @change="updateFilterValueOptions">
                <option value="">请选择...</option>
                <option v-for="dim in availableFilterDimensions" :key="dim.value" 
                        :value="dim.value" :disabled="dim.disabled">
                  {{ dim.label }}{{ dim.disabled ? ' (已添加)' : '' }}
                </option>
              </select>
            </div>
            <div v-if="newFilterDimension" class="filter-select-group">
              <label>选择筛选值：</label>
              <select v-model="newFilterValue">
                <option value="">请选择...</option>
                <option v-for="opt in currentFilterOptions" :key="opt.value" :value="opt.value">
                  {{ opt.value }} ({{ opt.count }})
                </option>
              </select>
            </div>
          </div>
          <div class="filter-dialog-footer">
            <button class="filter-btn filter-btn-cancel" @click="showFilterDialog = false">取消</button>
            <button class="filter-btn filter-btn-confirm" @click="confirmAddFilter">确定</button>
          </div>
        </div>
      </div>
    </transition>

    <!-- 快捷助手 -->
    <div ref="assistantHint" class="assistant-hint" :class="{ minimized: isScrolled }" @click="toggleQuickPanel">
      <span class="hint-icon">✨</span>
      <span class="hint-text">双击 <span class="kbd">空格</span> 唤醒口碑智能助手</span>
    </div>

    <!-- 快捷面板：遮罩不动画，面板自身过渡 -->
    <div v-if="showQuickPanel" class="quick-panel-overlay" @click.self="toggleQuickPanel">
      <transition name="slide-up">
        <div class="quick-panel">
          <iframe 
            src="https://chatkb.gausscode.com/chat/share?shareId=nfkhdg0g926tk1njsgttd76p" 
            frameborder="0" 
            allow="*"
          ></iframe>
        </div>
      </transition>
    </div>
    
    <!-- AI智能解读浮窗（无logo，窄宽 + 强打字机） -->
    <transition name="fade-slide">
      <div v-if="showAIAnalysis" class="ai-analysis-popup">
        <div class="ai-popup-header">
          <div class="ai-popup-title">AI智能解读</div>
          <button class="ai-popup-close" @click="closeAIAnalysis">×</button>
        </div>
        <div class="ai-popup-body">
          <div v-if="aiAnalyzing" class="ai-loading">
            <div class="ai-loading-dots"><span></span><span></span><span></span></div>
            <p>AI正在分析数据中...</p>
          </div>
          <div v-else class="ai-content">
            <div class="md-content" v-html="renderedHtml"></div>
            <span v-if="aiStreaming" class="cursor-blink">▊</span>
          </div>
        </div>
      </div>
    </transition>

    <!-- 优化向导 -->
    <OptimizationWizard
      v-if="showOptimizationWizard"
      :visible="showOptimizationWizard"
      :base-filters="filters"
      @cancel="showOptimizationWizard = false"
      @confirm="handleOptimizationConfirm"
      @need-load-data="loadFilterOptions"
    />

    <!-- Markdown 报告叠加层 -->
    <OptimizationMarkdownOverlay
      v-if="showOptimizationReport"
      :visible="showOptimizationReport"
      :data="optimizationReportData"
      @close="showOptimizationReport = false"
    />

  </div>
</template>

<script>
import * as echarts from 'echarts'
import 'echarts-wordcloud'
import dongchediApi from '../api/dongchediApi'
import aiApi from '../api/aiApi'
import RoleSelector from '../components/RoleSelector.vue'
import OptimizationWizard from '../components/OptimizationWizard.vue'
import OptimizationMarkdownOverlay from '../components/OptimizationMarkdownOverlay.vue'
import optimizationService from '../services/optimizationService'
import { renderMarkdown } from '../utils/markdown'

export default {
  name: 'Dashboard',
  components: {
    RoleSelector,
    OptimizationWizard,
    OptimizationMarkdownOverlay
  },
  data() {
    return {
      username: localStorage.getItem('username') || 'Admin',
      showFilters: false,
      filters: {
        sentiment: 'all',
        textType: 'all',
        complexity: 'all',
        carReviewType: 'all',
        fuelForm: 'all',
        year: 'all',
        seriesName: 'all',
        carName: 'all',
        startDate: '',
        endDate: ''
      },
      filterOptions: {
        sentiments: [],
        textTypes: [],
        complexities: [],
        carReviewTypes: [],
        fuelForms: [],
        years: [],
        seriesNames: [],
        carNames: []
      },
      stats: {},
      charts: {},
      showDetailModal: false,
      detailTitle: '',
      detailFilters: {},
      detailStats: {},
      detailDataList: [],
      showFilterDialog: false,
      newFilterDimension: '',
      newFilterValue: '',
      filterOptionsCache: {},
      showQuickPanel: false,
      isScrolled: false,
      // 搜索下拉框状态
      searchDropdowns: {
        sentiment: { open: false, search: '' },
        textType: { open: false, search: '' },
        complexity: { open: false, search: '' },
        carReviewType: { open: false, search: '' },
        fuelForm: { open: false, search: '' },
        year: { open: false, search: '' },
        seriesName: { open: false, search: '' },
        carName: { open: false, search: '' }
      },
      // 快速搜索下拉框状态
      showDropdown: {
        sentiment: false,
        seriesName: false,
        carName: false
      },
      // 快速搜索查询
      searchQueries: {
        sentiment: '',
        seriesName: '',
        carName: ''
      },
      spaceCount: 0,
      spaceTimer: null,
      // AI 解读
      showAIAnalysis: false,
      aiAnalyzing: false,
      aiStreaming: false,
      aiAnalysisText: '',
      displayedText: '',
      renderedHtml: '',
      // 优化入口状态
      showOptimizationWizard: false,
      showOptimizationReport: false,
      optimizationReportData: {}
    }
  },
  computed: {
    avgScore() {
      return this.stats.avg_score ? parseFloat(this.stats.avg_score).toFixed(2) : '0.00'
    },
    detailAvgScore() {
      return this.detailStats.avg_score ? parseFloat(this.detailStats.avg_score).toFixed(2) : '0.00'
    },
    availableFilterDimensions() {
      const allDimensions = [
        { value: 'sentiment', label: '情感倾向' },
        { value: 'textType', label: '文本类型' },
        { value: 'complexity', label: '句子复杂度' },
        { value: 'carReviewType', label: '评论类型' },
        { value: 'fuelForm', label: '燃料类型' },
        { value: 'year', label: '年份' },
        { value: 'seriesName', label: '车系' },
        { value: 'carName', label: '车型' }
      ]
      return allDimensions.map(dim => ({
        ...dim,
        disabled: this.detailFilters[dim.value] && this.detailFilters[dim.value] !== 'all' && this.detailFilters[dim.value] !== ''
      }))
    },
    currentFilterOptions() {
      const dimensionMap = {
        'sentiment': 'sentiments',
        'textType': 'textTypes',
        'complexity': 'complexities',
        'carReviewType': 'carReviewTypes',
        'fuelForm': 'fuelForms',
        'year': 'years',
        'seriesName': 'seriesNames',
        'carName': 'carNames'
      }
      const key = dimensionMap[this.newFilterDimension]
      return this.filterOptionsCache[key] || []
    },
    activeFiltersList() {
      const f = this.filters
      const list = []
      const add = (key, val) => {
        if (val && val !== 'all') list.push({ key, value: val })
      }
      add('sentiment', f.sentiment)
      add('textType', f.textType)
      add('complexity', f.complexity)
      add('carReviewType', f.carReviewType)
      add('fuelForm', f.fuelForm)
      add('year', f.year)
      add('seriesName', f.seriesName)
      add('carName', f.carName)
      return list
    },
    // 搜索过滤后的选项
    filteredOptions() {
      const result = {}
      const dimensions = ['sentiment', 'textType', 'complexity', 'carReviewType', 'fuelForm', 'year', 'seriesName', 'carName']
      
      dimensions.forEach(dim => {
        const key = this.getFilterOptionsKey(dim)
        const options = this.filterOptions[key] || []
        
        // 使用快速搜索查询或详细搜索查询
        let searchTerm = ''
        if (dim === 'sentiment' || dim === 'seriesName' || dim === 'carName') {
          searchTerm = this.searchQueries[dim].toLowerCase()
        } else {
          searchTerm = this.searchDropdowns[dim].search.toLowerCase()
        }
        
        result[dim] = searchTerm 
          ? options.filter(opt => opt.value.toLowerCase().includes(searchTerm))
          : options
      })
      
      return result
    }
  },
  mounted() {
    this.initCharts()
    this.loadFilterOptions()
    this.loadDashboardData()
    this.initKeyboardShortcut()
    this.initScrollListener()
  },
  beforeDestroy() {
    Object.values(this.charts).forEach(chart => chart && chart.dispose())
    window.removeEventListener('keydown', this.handleKeyDown)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 隐藏下拉框
    hideDropdown(type) {
      setTimeout(() => {
        if (type === 'sentiment') this.showDropdown.sentiment = false
        else if (type === 'seriesName') this.showDropdown.seriesName = false
        else if (type === 'carName') this.showDropdown.carName = false
      }, 200)
    },
    // 过滤选项
    filterOptions(type) {
      // 触发计算属性重新计算
      this.$forceUpdate()
    },
    // 选择选项
    selectOption(type, value) {
      if (type === 'sentiment') {
        this.filters.sentiment = value
        this.showDropdown.sentiment = false
      } else if (type === 'seriesName') {
        this.filters.seriesName = value
        this.showDropdown.seriesName = false
      } else if (type === 'carName') {
        this.filters.carName = value
        this.showDropdown.carName = false
      }
      this.applyFilters()
    },
    // 初始化图表
    initCharts() {
      this.charts.sentimentPie = echarts.init(this.$refs.sentimentPie)
      this.charts.wordCloud = echarts.init(this.$refs.wordCloud)
      this.charts.topicSentiment = echarts.init(this.$refs.topicSentiment)

      // 绑定点击事件
      this.charts.sentimentPie.on('click', (params) => {
        const sentimentMap = { '正面': 'positive', '负面': 'negative', '中性': 'neutral' }
        const sentiment = sentimentMap[params.name]
        if (sentiment) {
          this.openDetailModal(`${params.name}情感数据详情`, { sentiment })
        }
      })

      this.charts.wordCloud.on('click', (params) => {
        if (params.name) {
          this.openDetailModal(`"${params.name}"关键词数据详情`, { keyword: params.name })
        }
      })

      this.charts.topicSentiment.on('click', (params) => {
        if (params.name) {
          this.openDetailModal(`"${params.name}"相关数据详情`, { keyword: params.name })
        }
      })

      window.addEventListener('resize', () => {
        Object.values(this.charts).forEach(chart => chart && chart.resize())
      })
    },

    // 加载筛选选项
    async loadFilterOptions() {
      try {
        const facets = await dongchediApi.getFilterFacets(this.filters)
        this.filterOptions = facets
        
        // 将车系和车型选项存储到Vuex store中
        if (facets.seriesNames && facets.carNames) {
          this.$store.dispatch('updateSeriesOptions', facets.seriesNames)
          this.$store.dispatch('updateCarOptions', facets.carNames)
        }
      } catch (error) {
        console.error('加载筛选选项失败:', error)
      }
    },

    // 加载看板数据
    async loadDashboardData() {
      try {
        const [stats, sentimentDist, wordCloud, topicSentiment] = await Promise.all([
          dongchediApi.getSentimentStats(this.filters),
          dongchediApi.getSentimentDistribution(this.filters),
          dongchediApi.getWordCloudAspects(this.filters),
          dongchediApi.getTopicSentimentDistribution(this.filters)
        ])

        this.stats = stats
        this.updateSentimentPieChart(sentimentDist)
        this.updateWordCloudChart(wordCloud)
        this.updateTopicSentimentChart(topicSentiment)

        // 触发AI解读
        this.triggerAIAnalysis({ stats, sentimentDist, wordCloud, topicSentiment })
      } catch (error) {
        console.error('加载数据失败:', error)
        alert('加载数据失败，请检查网络连接')
      }
    },

    // 更新情感饼图
    updateSentimentPieChart(data) {
      const sentimentMap = {
        positive: '正面',
        negative: '负面',
        neutral: '中性'
      }
      const colorMap = {
        '正面': '#7da2ff',
        '负面': '#4e5ae0',
        '中性': '#95a2ff'
      }
      const chartData = data.map(item => ({
        name: sentimentMap[item.sentiment] || item.sentiment,
        value: parseInt(item.count),
        itemStyle: { color: colorMap[sentimentMap[item.sentiment] || item.sentiment] || '#7b88f7' }
      }))

      this.charts.sentimentPie.setOption({
        tooltip: { trigger: 'item' },
        legend: { bottom: '5%', left: 'center' },
        series: [{
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: { show: true, formatter: '{b}: {c} ({d}%)' },
          data: chartData
        }]
      })
    },

    // 更新词云图
    updateWordCloudChart(data) {
      const negativeWords = ['差', '不好', '失望', '故障', '问题', '异响', '漏油', '投诉', '抖动', '刹车', '危险', '糟糕', '差劲', '不推荐', '漏水', '卡顿', '异味']
      const palette = ['#8ea0f7', '#7da2ff', '#6b7df6', '#5a63d8', '#7b69da']
      const chartData = data.map(item => {
        const name = item.keyword
        const isNeg = negativeWords.some(n => name && name.includes(n))
        const color = isNeg ? '#fecaca' : palette[Math.floor(Math.random() * palette.length)]
        return {
          name,
          value: parseInt(item.count),
          textStyle: { color }
        }
      })

      this.charts.wordCloud.setOption({
        tooltip: {},
        series: [{
          type: 'wordCloud',
          shape: 'circle',
          sizeRange: [14, 60],
          rotationRange: [0, 0],
          gridSize: 8,
          drawOutOfBound: false,
          layoutAnimation: true,
          textStyle: {
            fontFamily: 'sans-serif',
            fontWeight: 'bold'
          },
          data: chartData
        }]
      })
    },

    // 更新话题情绪图
    updateTopicSentimentChart(data) {
      const aspects = [...new Set(data.map(item => item.aspect))]
      const sentiments = ['positive', 'negative', 'neutral']
      const sentimentMap = { positive: '正面', negative: '负面', neutral: '中性' }
      const colors = { positive: '#7da2ff', negative: '#4e5ae0', neutral: '#95a2ff' }

      const series = sentiments.map(sentiment => ({
        name: sentimentMap[sentiment],
        type: 'bar',
        stack: 'total',
        data: aspects.map(aspect => {
          const found = data.find(d => d.aspect === aspect && d.sentiment === sentiment)
          return found ? parseInt(found.count) : 0
        }),
        itemStyle: { color: colors[sentiment] }
      }))

      this.charts.topicSentiment.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        legend: { data: Object.values(sentimentMap) },
        grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
        xAxis: { type: 'value' },
        yAxis: { type: 'category', data: aspects },
        series: series
      })
    },

    // 应用筛选
    async applyFilters() {
      await Promise.all([
        this.loadFilterOptions(),
        this.loadDashboardData()
      ])
    },

    // 重置筛选
    resetFilters() {
      this.filters = {
        sentiment: 'all',
        textType: 'all',
        complexity: 'all',
        carReviewType: 'all',
        fuelForm: 'all',
        year: 'all',
        seriesName: 'all',
        carName: 'all',
        startDate: '',
        endDate: ''
      }
      this.applyFilters()
    },

    // 打开详情弹窗
    async openDetailModal(title, extraFilters = {}) {
      this.detailTitle = title
      this.detailFilters = { ...this.filters, ...extraFilters }
      this.showDetailModal = true

      // 预加载筛选选项
      this.loadDetailFilterOptions()
      
      // 加载详情数据
      await this.loadDetailData()
    },

    // 关闭详情弹窗
    closeDetailModal() {
      this.showDetailModal = false
      this.filterOptionsCache = {}
    },

    // 加载详情数据
    async loadDetailData() {
      try {
        const [detailData, stats] = await Promise.all([
          dongchediApi.getAspectAnalysis(this.detailFilters),
          dongchediApi.getSentimentStats(this.detailFilters)
        ])
        this.detailDataList = detailData
        this.detailStats = stats
      } catch (error) {
        console.error('加载详情数据失败:', error)
      }
    },

    // 加载详情筛选选项
    async loadDetailFilterOptions() {
      try {
        this.filterOptionsCache = await dongchediApi.getFilterFacets(this.detailFilters)
      } catch (error) {
        console.error('预加载筛选选项失败:', error)
      }
    },

    // 移除详情筛选条件
    removeDetailFilter(key) {
      this.$delete(this.detailFilters, key)
      this.loadDetailData()
    },

    // 更新筛选值选项
    updateFilterValueOptions() {
      this.newFilterValue = ''
    },

    // 确认添加筛选
    confirmAddFilter() {
      if (!this.newFilterDimension || !this.newFilterValue) {
        alert('请选择筛选维度和值')
        return
      }
      this.$set(this.detailFilters, this.newFilterDimension, this.newFilterValue)
      this.showFilterDialog = false
      this.newFilterDimension = ''
      this.newFilterValue = ''
      this.loadDetailData()
    },

    // 获取筛选标签
    getFilterLabel(key) {
      const labels = {
        sentiment: '情感倾向',
        textType: '文本类型',
        complexity: '句子复杂度',
        carReviewType: '评论类型',
        fuelForm: '燃料类型',
        year: '年份',
        seriesName: '车系',
        carName: '车型',
        startDate: '开始日期',
        endDate: '结束日期',
        keyword: '关键词'
      }
      return labels[key] || key
    },

    // 获取筛选选项的key映射
    getFilterOptionsKey(dimension) {
      const keyMap = {
        sentiment: 'sentiments',
        textType: 'textTypes',
        complexity: 'complexities',
        carReviewType: 'carReviewTypes',
        fuelForm: 'fuelForms',
        year: 'years',
        seriesName: 'seriesNames',
        carName: 'carNames'
      }
      return keyMap[dimension] || dimension
    },

    // 搜索下拉框方法
    toggleSearchDropdown(dimension) {
      // 关闭所有其他下拉框
      Object.keys(this.searchDropdowns).forEach(key => {
        if (key !== dimension) {
          this.searchDropdowns[key].open = false
        }
      })
      // 切换当前下拉框
      this.searchDropdowns[dimension].open = !this.searchDropdowns[dimension].open
    },

    selectSearchOption(dimension, value) {
      this.filters[dimension] = value
      this.searchDropdowns[dimension].open = false
      this.searchDropdowns[dimension].search = ''
    },

    clearSearch(dimension) {
      this.searchDropdowns[dimension].search = ''
    },

    // 点击外部关闭下拉框
    closeAllSearchDropdowns() {
      Object.keys(this.searchDropdowns).forEach(key => {
        this.searchDropdowns[key].open = false
      })
    },

    // 获取情感类名
    getSentimentClass(sentiment) {
      return sentiment || 'neutral'
    },

    // 获取情感标签
    getSentimentLabel(sentiment) {
      const map = { positive: '正面', negative: '负面', neutral: '中性' }
      return map[sentiment] || '未知'
    },

    // 解析aspect
    getAspects(opinionAnalysis) {
      if (!opinionAnalysis) return []
      try {
        let data = opinionAnalysis
        if (typeof data === 'string') {
          data = JSON.parse(data)
        }
        if (Array.isArray(data)) {
          return data.map(item => item.aspect).filter(Boolean)
        }
        return []
      } catch (e) {
        return []
      }
    },

    // 快捷面板
    toggleQuickPanel() {
      this.showQuickPanel = !this.showQuickPanel
    },

    // 键盘快捷键
    initKeyboardShortcut() {
      window.addEventListener('keydown', this.handleKeyDown)
    },

    handleKeyDown(e) {
      if (e.code === 'Space' && e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault()
        clearTimeout(this.spaceTimer)
        this.spaceCount++
        if (this.spaceCount === 2) {
          this.toggleQuickPanel()
          this.spaceCount = 0
        }
        this.spaceTimer = setTimeout(() => {
          this.spaceCount = 0
        }, 500)
      }
    },

    // 滚动监听
    initScrollListener() {
      window.addEventListener('scroll', this.handleScroll)
    },

    handleScroll() {
      this.isScrolled = window.scrollY > 100
    },

    // 退出登录
    logout() {
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('username')
      localStorage.removeItem('loginTime')
      this.$router.push('/login')
    },

    // 角色选择变化
    handleRoleChanged(newRole) {
      console.log('角色已更改为:', newRole)
      // 可以在这里添加角色变化后的逻辑，例如根据角色调整界面显示
    },

    // ===== AI 解读 =====
    async triggerAIAnalysis(datasets) {
      try {
        this.showAIAnalysis = true
        this.aiAnalyzing = true
        this.aiStreaming = true
        this.aiAnalysisText = ''
        this.displayedText = ''

        // 获取当前用户角色信息
        const userRole = localStorage.getItem('userRole') || '普通用户'
        const userRoleValue = localStorage.getItem('userRoleValue') || 'normal_user'

        // 收集Top方面的原话证据（增强：覆盖范围更广、每方面多条原话）
        const topic = datasets.topicSentiment || []
        const topNegAspects = topic
          .filter(t => t.sentiment === 'negative')
          .sort((a, b) => parseInt(b.count) - parseInt(a.count))
          .slice(0, 3)
          .map(t => t.aspect)
        const topPosAspects = topic
          .filter(t => t.sentiment === 'positive')
          .sort((a, b) => parseInt(b.count) - parseInt(a.count))
          .slice(0, 2)
          .map(t => t.aspect)
        const targetAspects = Array.from(new Set([ ...topNegAspects, ...topPosAspects ]))
        const quotesByAspect = {}
        for (const asp of targetAspects) {
          try {
            const rows = await dongchediApi.getAspectAnalysis({ ...this.filters, keyword: asp })
            const pos = rows
              .filter(r => r.sentiment === 'positive')
              .slice(0, 3)
              .map(r => r.original_sentence)
            const neg = rows
              .filter(r => r.sentiment === 'negative')
              .slice(0, 3)
              .map(r => r.original_sentence)
            quotesByAspect[asp] = { positive: pos, negative: neg }
          } catch (e) {
            // 单个方面证据获取失败不影响整体
          }
        }

        // 趋势证据：最近30天 vs 前30天的正面率与平均情感分变化
        const end = new Date()
        const toISO = (d) => new Date(d.getTime() - (d.getTimezoneOffset() * 60000)).toISOString().slice(0, 19).replace('T', ' ')
        const recentStart = new Date(end.getTime() - 30 * 24 * 60 * 60 * 1000)
        const prevStart = new Date(recentStart.getTime() - 30 * 24 * 60 * 60 * 1000)
        const recentStats = await dongchediApi.getSentimentStats({ ...this.filters, startDate: toISO(recentStart), endDate: toISO(end) })
        const prevStats = await dongchediApi.getSentimentStats({ ...this.filters, startDate: toISO(prevStart), endDate: toISO(recentStart) })
        const safeRate = (s) => {
          const total = parseInt(s.total_count || 0)
          const pos = parseInt(s.positive_count || 0)
          return total > 0 ? (pos / total * 100).toFixed(1) : '0.0'
        }
        const trend = {
          recent: { positiveRate: safeRate(recentStats), avgScore: parseFloat(recentStats.avg_score || 0).toFixed(2) },
          previous: { positiveRate: safeRate(prevStats), avgScore: parseFloat(prevStats.avg_score || 0).toFixed(2) }
        }

        // 伴随关系证据：近60天内各条原话中的多方面共同出现（粗粒度）
        let cooccurrence = []
        try {
          const sixtyStart = new Date(end.getTime() - 60 * 24 * 60 * 60 * 1000)
          const rows = await dongchediApi.getAspectAnalysis({ ...this.filters, startDate: toISO(sixtyStart), endDate: toISO(end) })
          const pairCount = {}
          rows.forEach(r => {
            try {
              const arr = JSON.parse(r.opinion_analysis || '[]')
              const aspects = (arr || []).map(x => x.aspect).filter(Boolean)
              for (let i = 0; i < aspects.length; i++) {
                for (let j = i + 1; j < aspects.length; j++) {
                  const a = aspects[i]
                  const b = aspects[j]
                  const key = a < b ? `${a}__${b}` : `${b}__${a}`
                  pairCount[key] = (pairCount[key] || 0) + 1
                }
              }
            } catch (e) {}
          })
          cooccurrence = Object.entries(pairCount)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 5)
            .map(([key, cnt]) => {
              const [a, b] = key.split('__')
              return { pair: [a, b], count: cnt }
            })
        } catch (e) {}

        const evidence = { quotesByAspect, trend, cooccurrence }

        const prompt = aiApi.generateDashboardPrompt(
          datasets.stats,
          datasets.sentimentDist,
          datasets.wordCloud,
          datasets.topicSentiment,
          this.filters,
          userRole,
          userRoleValue,
          evidence
        )

        await aiApi.analyzeData(prompt, (chunk, fullText) => {
          this.aiAnalyzing = false
          this.aiAnalysisText = fullText
          // 直接显示流式返回的文本，不需要额外的打字机动画（API本身已经是流式的）
          this.displayedText = fullText
          this.renderedHtml = renderMarkdown(fullText)
        })

        this.aiStreaming = false
      } catch (e) {
        console.error('AI分析失败:', e)
        this.aiAnalyzing = false
        this.aiStreaming = false
        this.aiAnalysisText = '抱歉，AI分析暂时不可用，请稍后再试。'
        this.displayedText = this.aiAnalysisText
      }
    },

    closeAIAnalysis() {
      this.showAIAnalysis = false
      this.aiAnalyzing = false
      this.aiStreaming = false
      this.aiAnalysisText = ''
      this.displayedText = ''
      this.renderedHtml = ''
    },


    // 跳转到对比页面
    goToComparison() {
      this.$router.push('/comparison')
    },

    // ===== 优化入口与报告 =====
    openOptimizationWizard() {
      if (!this.filterOptions.seriesNames?.length || !this.filterOptions.carNames?.length) {
        this.loadFilterOptions().then(() => {
          this.showOptimizationWizard = true
        })
      } else {
        this.showOptimizationWizard = true
      }
    },

    async handleOptimizationConfirm(payload) {
      try {
        // 关闭向导，立即打开报告窗口（AI内容可后续流式填充）
        this.showOptimizationWizard = false

        // 用户角色与一般诉求（角色说明）
        const userRole = localStorage.getItem('userRole') || '普通用户'
        const userRoleValue = localStorage.getItem('userRoleValue') || 'normal_user'
        const roleDescriptions = {
          'normal_user': '关注产品使用体验和口碑评价',
          'product_manager': '关注产品功能与用户体验',
          'marketing': '关注品牌形象与市场反馈',
          'data_analyst': '关注数据洞察与趋势分析',
          'developer': '关注技术实现与性能优化',
          'executive': '关注整体业务与战略决策'
        }
        const roleDescription = roleDescriptions[userRoleValue] || '关注产品使用体验和口碑评价'

        // 先以当前页面卡片数据构建初始上下文，立即展示
        const initialContext = {
          timestamp: new Date().toISOString(),
          filters: payload.filters || this.filters || {},
          target: payload.target,
          selectedObjects: payload.selectedObjects || [],
          competitors: payload.competitors || {},
          selectedAspects: payload.selectedAspects || [],
          // 关键：卡片数据直接放入上下文，报告页可立即显示
          aspectInsights: payload.aspectInsights || {},
          aspectMetrics: payload.aspectMetrics || {},
          // 角色信息
          userRole,
          userRoleValue,
          roleDescription
        }

        this.optimizationReportData = { context: initialContext, markdown: 'AI 正在生成报告...' }
        this.showOptimizationReport = true

        // 异步补充完整上下文（聚合统计/策略池/预测等）
        const context = await optimizationService.prepareContext(payload, this.filters, userRole, userRoleValue)
        const fullContext = { ...context, aspectInsights: payload.aspectInsights || {}, aspectMetrics: payload.aspectMetrics || {}, roleDescription }
        this.optimizationReportData = { ...this.optimizationReportData, context: fullContext }

        // 生成提示词并流式更新Markdown
        const prompt = aiApi.generateOptimizationMarkdownPrompt(fullContext)
        await aiApi.analyzeData(prompt, (chunk, fullText) => {
          this.optimizationReportData = { ...this.optimizationReportData, markdown: fullText }
        })
      } catch (e) {
        console.error('生成优化报告失败:', e)
        // 保持窗口打开但提示错误文案
        this.optimizationReportData = { ...(this.optimizationReportData || {}), markdown: '抱歉，AI报告生成暂不可用，请稍后重试。' }
        this.showOptimizationReport = true
      }
    }
  }
}
</script>

<style scoped>
/* 基础样式 - 已压缩，保留完整功能 */
.dashboard { 
  /* 统一蓝紫主题变量 */
  --brand-start: #5b6df2; /* 蓝 */
  --brand-end: #7b5cff;   /* 蓝紫 */
  --brand-50: #eef2ff;
  --brand-100: #e3e8ff;
  --brand-300: #a5b4fc;
  --brand-400: #818cf8;
  --brand-500: #667eea;
  --brand-600: #5a63d8;
  --brand-700: #4c54c8;
  background: linear-gradient(135deg, var(--brand-50) 0%, var(--brand-100) 100%);
  min-height: 100vh; padding: 15px; 
}
.header { text-align: center; margin-bottom: 16px; padding: 18px; background: rgba(255,255,255,0.95); backdrop-filter: blur(10px); border-radius: 20px; box-shadow: 0 8px 32px rgba(0,0,0,0.1); position: relative; z-index: 3; }
.header h1 { font-size: 32px; font-weight: 700; background: linear-gradient(135deg, var(--brand-start) 0%, var(--brand-end) 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; margin-bottom: 8px; }
.header p { color: #718096; font-size: 16px; }
.user-info { position: absolute; top: 20px; right: 25px; display: flex; align-items: center; gap: 12px; }
.username { color: #4a5568; font-size: 14px; font-weight: 500; }
.btn-logout { padding: 8px 16px; background: linear-gradient(135deg, var(--brand-start) 0%, var(--brand-end) 100%); color: white; border: none; border-radius: 6px; font-size: 13px; cursor: pointer; transition: all 0.2s; }
.btn-logout:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(102,126,234,0.4); }

/* 顶部工具栏（标题与筛选一体化） */
.top-toolbar { margin-top: 12px; display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 12px; background: rgba(246,248,255,0.9); border: 1px solid #e2e8f0; border-radius: 12px; }
.toolbar-left { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
.quick-filters { display: flex; align-items: center; gap: 10px; }
.quick-filter-item { display: flex; align-items: center; gap: 6px; }
.quick-filter-item label { font-size: 12px; color: #4a5568; }
.quick-filter-item select { padding: 6px 8px; border: 1px solid #cbd5e0; border-radius: 8px; font-size: 13px; }
.active-filter-tags { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.filter-tag { padding: 4px 10px; background: #eef2ff; border: 1px solid #e2e8f0; border-radius: 12px; font-size: 12px; color: #374151; }
.toolbar-right { display: flex; align-items: center; gap: 8px; }
.btn-compare { padding: 8px 16px; border: none; border-radius: 8px; font-size: 13px; background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%); color: white; cursor: pointer; font-weight: 600; transition: all 0.2s; }
.btn-compare:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(245,158,11,0.4); }
.btn-toggle-filters { padding: 8px 12px; border: none; border-radius: 8px; font-size: 13px; background: #edf2f7; color: #4a5568; cursor: pointer; }

/* 筛选区域 */
.filter-section { background: rgba(255,255,255,0.95); backdrop-filter: blur(10px); border-radius: 16px; padding: 16px; margin-bottom: 16px; box-shadow: 0 8px 24px rgba(0,0,0,0.08); }
.filter-section h2 { font-size: 18px; margin-bottom: 15px; color: #2d3748; display: flex; align-items: center; }
.filter-section h2::before { content: '🔍'; margin-right: 8px; }
.filter-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 12px; margin-bottom: 12px; }
.filter-item label { display: block; margin-bottom: 5px; font-size: 13px; font-weight: 500; color: #4a5568; }
.filter-item select, .filter-item input { width: 100%; padding: 10px; border: 1px solid #cbd5e0; border-radius: 8px; font-size: 14px; transition: all 0.2s; }
.filter-item select:focus, .filter-item input:focus { outline: none; border-color: #667eea; box-shadow: 0 0 0 3px rgba(102,126,234,0.1); }
.filter-actions { display: flex; gap: 10px; justify-content: flex-end; }
.btn-reset, .btn-apply { padding: 10px 20px; border: none; border-radius: 8px; font-size: 14px; font-weight: 500; cursor: pointer; transition: all 0.2s; }
.btn-reset { background: #edf2f7; color: #4a5568; }
.btn-apply { background: linear-gradient(135deg, var(--brand-start) 0%, var(--brand-end) 100%); color: white; }
.btn-optimize { padding: 10px 20px; border: none; border-radius: 8px; font-size: 14px; font-weight: 600; cursor: pointer; background: linear-gradient(135deg, #5b6df2 0%, #7b5cff 100%); color: #fff; }

/* 可搜索下拉框样式 */
.searchable-select { position: relative; width: 100%; z-index: 100; }
.search-input { width: 100%; padding: 10px; border: 1px solid #cbd5e0; border-radius: 8px; font-size: 14px; transition: all 0.2s; background: white; }
.search-input:focus { outline: none; border-color: #667eea; box-shadow: 0 0 0 3px rgba(102,126,234,0.1); }
.dropdown-list { position: absolute; top: 100%; left: 0; right: 0; background: white; border: 1px solid #cbd5e0; border-top: none; border-radius: 0 0 8px 8px; max-height: 200px; overflow-y: auto; z-index: 99999; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
.dropdown-item { padding: 8px 12px; cursor: pointer; font-size: 14px; transition: background-color 0.2s; }
.dropdown-item:hover { background-color: #f7fafc; }
.dropdown-item:first-child { border-top: 1px solid #e2e8f0; }

/* 指标卡片 */
.metrics-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 20px; margin-bottom: 25px; }
.metric-card { background: white; border-radius: 16px; padding: 20px; display: flex; align-items: center; gap: 15px; box-shadow: 0 4px 16px rgba(0,0,0,0.08); transition: all 0.3s; }
.metric-card:hover { transform: translateY(-4px); box-shadow: 0 8px 24px rgba(0,0,0,0.12); }
.metric-card.clickable { cursor: pointer; }
.metric-card.clickable:active { transform: translateY(-2px) scale(0.995); }
.metric-card.positive { background: linear-gradient(135deg, var(--brand-400) 0%, var(--brand-500) 100%); color: white; }
.metric-card.negative { background: linear-gradient(135deg, var(--brand-600) 0%, var(--brand-700) 100%); color: white; }
.metric-card.neutral { background: linear-gradient(135deg, var(--brand-300) 0%, var(--brand-400) 100%); color: white; }
.metric-card.score { background: linear-gradient(135deg, var(--brand-500) 0%, var(--brand-600) 100%); color: white; }
.metric-icon { font-size: 36px; }
.metric-value { font-size: 28px; font-weight: 700; }
.metric-label { font-size: 14px; opacity: 0.9; }

/* 图表 */
.charts-row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 20px; }
.chart-card { background: white; border-radius: 16px; padding: 20px; box-shadow: 0 4px 16px rgba(0,0,0,0.08); }
.chart-card.half { min-height: 400px; }
.chart-card h3 { font-size: 18px; margin-bottom: 15px; color: #2d3748; }
.chart { width: 100%; height: 350px; }

/* 详情弹窗 */
.detail-modal { position: fixed; inset: 0; background: rgba(0,0,0,0.6); display: flex; align-items: center; justify-content: center; z-index: 10000; }
.detail-modal-content { background: white; border-radius: 16px; width: 90vw; max-width: 1200px; max-height: 85vh; overflow: hidden; display: flex; flex-direction: column; box-shadow: 0 20px 60px rgba(0,0,0,0.3); }
.detail-modal-header { padding: 24px 28px; border-bottom: 1px solid #e2e8f0; display: flex; align-items: center; justify-content: space-between; background: linear-gradient(135deg, var(--brand-start) 0%, var(--brand-end) 100%); color: white; }
.detail-modal-title { font-size: 20px; font-weight: 600; display: flex; align-items: center; gap: 10px; }
.detail-modal-close { width: 32px; height: 32px; border: none; background: rgba(255,255,255,0.2); color: white; border-radius: 50%; cursor: pointer; font-size: 20px; }
.detail-modal-filters { padding: 16px 28px; background: #f7fafc; border-bottom: 1px solid #e2e8f0; display: flex; flex-wrap: wrap; gap: 10px; }
.detail-filter-tag { display: inline-flex; align-items: center; gap: 8px; padding: 6px 12px; background: white; border: 1px solid #cbd5e0; border-radius: 16px; font-size: 13px; }
.remove-filter { width: 18px; height: 18px; border: none; background: #e2e8f0; border-radius: 50%; cursor: pointer; font-size: 12px; }
.add-filter-btn { padding: 6px 16px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; border: none; border-radius: 16px; font-size: 13px; cursor: pointer; }
.detail-modal-body { flex: 1; overflow-y: auto; padding: 24px 28px; }
.detail-stats { display: grid; grid-template-columns: repeat(5, 1fr); gap: 16px; margin-bottom: 24px; }
.stat-item { text-align: center; padding: 16px; background: #f7fafc; border-radius: 12px; }
.stat-item.positive { background: #e6ecff; }
.stat-item.negative { background: #dce4ff; }
.stat-item.neutral { background: #f0f3ff; }
.stat-label { display: block; font-size: 13px; color: #718096; margin-bottom: 8px; }
.stat-value { display: block; font-size: 24px; font-weight: 700; color: #2d3748; }
.detail-data-list { display: grid; gap: 16px; }
.detail-data-item { padding: 20px; background: white; border: 1px solid #e2e8f0; border-radius: 12px; }
.detail-item-header { display: flex; justify-content: space-between; margin-bottom: 12px; }
.detail-item-meta { display: flex; gap: 16px; flex-wrap: wrap; }
.detail-meta-tag { font-size: 12px; color: #718096; }
.detail-sentiment-badge { padding: 4px 12px; border-radius: 12px; font-size: 12px; font-weight: 600; }
.detail-sentiment-badge.positive { background: #e6ecff; color: #2d3aa7; }
.detail-sentiment-badge.negative { background: #dce4ff; color: #24308f; }
.detail-sentiment-badge.neutral { background: #f0f3ff; color: #3645a7; }
.detail-item-content { font-size: 15px; line-height: 1.6; padding: 12px; background: #f3f6ff; border-radius: 8px; margin-bottom: 12px; }
.detail-item-tags { display: flex; gap: 8px; flex-wrap: wrap; }
.detail-tag { padding: 4px 10px; background: #eef2ff; border-radius: 6px; font-size: 12px; }

/* 筛选对话框 */
.filter-dialog { position: fixed; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 10001; }
.filter-dialog-content { background: white; border-radius: 16px; width: 90%; max-width: 500px; box-shadow: 0 20px 60px rgba(0,0,0,0.3); }
.filter-dialog-header { padding: 20px 24px; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; background: linear-gradient(135deg, var(--brand-start) 0%, var(--brand-end) 100%); color: white; border-radius: 16px 16px 0 0; }
.filter-dialog-header h3 { margin: 0; font-size: 18px; }
.filter-dialog-close { width: 28px; height: 28px; border: none; background: rgba(255,255,255,0.2); color: white; border-radius: 50%; cursor: pointer; }
.filter-dialog-body { padding: 24px; }
.filter-select-group { margin-bottom: 20px; }
.filter-select-group label { display: block; margin-bottom: 8px; font-size: 14px; font-weight: 500; }
.filter-select-group select { width: 100%; padding: 10px 12px; border: 1px solid #cbd5e0; border-radius: 8px; }
.filter-dialog-footer { padding: 16px 24px; border-top: 1px solid #e2e8f0; display: flex; gap: 12px; justify-content: flex-end; }
.filter-btn { padding: 10px 24px; border: none; border-radius: 8px; font-size: 14px; cursor: pointer; }
.filter-btn-cancel { background: #edf2f7; color: #4a5568; }
.filter-btn-confirm { background: linear-gradient(135deg, var(--brand-start) 0%, var(--brand-end) 100%); color: white; }

/* 快捷助手 */
.assistant-hint { position: fixed; bottom: 30px; left: 50%; transform: translateX(-50%); background: linear-gradient(135deg, rgba(91,109,242,0.95) 0%, rgba(123,92,255,0.95) 100%); color: white; padding: 12px 24px; border-radius: 24px; font-size: 14px; box-shadow: 0 4px 16px rgba(102,126,234,0.3); cursor: pointer; z-index: 8888; transition: all 0.3s; }
.assistant-hint.minimized { transform: translateX(-50%) scale(0.3); opacity: 0.6; }
.assistant-hint:hover { transform: translateX(-50%) scale(1.05); }
.hint-icon { font-size: 16px; }
.kbd { padding: 2px 6px; background: rgba(255,255,255,0.2); border-radius: 4px; font-size: 12px; }

/* 快捷面板 */
.quick-panel-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.6); display: flex; align-items: center; justify-content: center; z-index: 9999; }
.quick-panel { width: 52vw; height: 82vh; background: white; border-radius: 16px; overflow: hidden; box-shadow: 0 20px 60px rgba(0,0,0,0.3); }
.quick-panel iframe { width: 100%; height: 100%; }

/* 动画 */
.modal-enter-active, .modal-leave-active { transition: opacity 0.25s; }
.modal-enter, .modal-leave-to { opacity: 0; }
.slide-up-enter-active, .slide-up-leave-active { transition: all 0.35s cubic-bezier(.22,.61,.36,1); }
.slide-up-enter { opacity: 0; transform: scale(0.9) translateY(20px); }
.slide-up-leave-to { opacity: 0; transform: scale(0.9) translateY(20px); }

/* 响应式 */
@media (max-width: 768px) {
  .charts-row { grid-template-columns: 1fr; }
  .metrics-grid { grid-template-columns: 1fr 1fr; }
  .detail-stats { grid-template-columns: repeat(3, 1fr); }
}
/* AI智能解读浮窗样式（更窄、无logo） */
.ai-analysis-popup { position: fixed; bottom: 20px; right: 20px; width: 320px; max-width: calc(100vw - 40px); background: linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(250,251,252,0.98) 100%); backdrop-filter: blur(18px); border-radius: 12px; box-shadow: 0 18px 48px rgba(0,0,0,0.14), 0 0 0 1px rgba(0,0,0,0.05); z-index: 10000; overflow: hidden; animation: popup-bounce 0.38s cubic-bezier(0.68,-0.55,0.265,1.55); }
@keyframes popup-bounce { 0% { transform: scale(0.92) translateY(12px); opacity: 0; } 60% { transform: scale(1.03) translateY(-4px); } 100% { transform: scale(1) translateY(0); opacity: 1; } }
.ai-popup-header { display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: #fff; font-weight: 600; font-size: 14px; }
.ai-popup-title { letter-spacing: .5px; }
.ai-popup-close { background: rgba(255,255,255,0.2); border: none; color: white; width: 24px; height: 24px; border-radius: 50%; font-size: 18px; line-height: 1; cursor: pointer; transition: all 0.25s ease; display: flex; align-items: center; justify-content: center; }
.ai-popup-close:hover { background: rgba(255,255,255,0.28); transform: rotate(90deg); }
.ai-popup-body { padding: 14px; max-height: 360px; overflow-y: auto; }
.ai-content { font-size: 13px; line-height: 1.75; color: #1e293b; white-space: pre-wrap; word-wrap: break-word; }
.typewriter-char { display: inline; animation: char-pop .08s ease-out; }
@keyframes char-pop { 0% { opacity: 0; transform: translateY(2px); } 100% { opacity: 1; transform: translateY(0); } }
.cursor-blink { display: inline-block; animation: blink .7s step-end infinite; color: #667eea; font-weight: bold; margin-left: 2px; font-size: 14px; }
@keyframes blink { 0%, 50% { opacity: 1; } 51%, 100% { opacity: 0; } }

/* Markdown 内容样式（受控简洁，适配弹窗窄宽） */
.md-content { font-size: 13px; line-height: 1.7; color: #1e293b; }
.md-content h1, .md-content h2, .md-content h3 { margin: 6px 0 4px; font-weight: 700; }
.md-content h1 { font-size: 16px; }
.md-content h2 { font-size: 15px; }
.md-content h3 { font-size: 14px; }
.md-content p { margin: 6px 0; }
.md-content ul, .md-content ol { padding-left: 18px; margin: 6px 0; }
.md-content code { background: #f4f6fb; border-radius: 4px; padding: 0 4px; font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; font-size: 12px; }
.md-content pre code { display: block; padding: 10px; overflow-x: auto; }
.md-content blockquote { margin: 8px 0; padding: 6px 10px; border-left: 3px solid #a5b4fc; background: #f8f9ff; color: #334155; }
.md-content table { width: 100%; border-collapse: collapse; margin: 8px 0; font-size: 12px; }
.md-content thead th { background: #eef2ff; color: #334155; font-weight: 700; }
.md-content th, .md-content td { border: 1px solid #e5e7eb; padding: 6px 8px; text-align: left; }
.md-content tbody tr:nth-child(odd) { background: #fafafa; }
.md-content a { color: #667eea; text-decoration: none; }
.md-content a:hover { text-decoration: underline; }

.fade-slide-enter-active, .fade-slide-leave-active { transition: all 0.35s ease; }
.fade-slide-enter, .fade-slide-leave-to { opacity: 0; transform: translateY(16px) scale(0.98); }

@media (max-width: 768px) { .ai-analysis-popup { bottom: 16px; right: 16px; width: calc(100vw - 32px); } }

</style>

